import React, { useContext, useState } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import {
  Col, Form, Modal, Radio, Row, Typography
} from 'antd'
import classNames from 'classnames'

import { Button } from 'src/components/Button'
import { InfoModal } from 'src/components/Modal'
import { Spacer } from 'src/components/Spacer'
import { Switch } from 'src/components/Switch'
import { useDisplay } from 'src/hooks/useDisplay'
import { useNewTransaction } from 'src/hooks/useNewTransaction'
import { EnumNewTransactionParams } from 'src/router/types'
import { store } from 'src/store/store'

import './styles.scss'

const { Text, Title } = Typography

export default function NewTransactionFeeConfirm() {
  const { navigateToStep, isSeller } = useNewTransaction()
  const globalStore = useContext(store)
  const [form] = Form.useForm()
  const { smallModalWidth, largeModalWidth } = useDisplay()
  const [showInfoModal, setShowInfoModal] = useState(false)
  const [showOptionSelectedConfirmation, setShowOptionSelectedConfirmation] = useState(false)
  const [infoText, setInfoText] = useState('')

  const {
    documentEnabled,
    paymentTransfer,
    askBuyerPayForTheFees
  } = globalStore.state.createTransaction

  const {
    enabled: paymentTransferEnabled,
    protectionEnabled
  } = paymentTransfer

  const submitForm = () => {
    setShowInfoModal(false)
    setShowOptionSelectedConfirmation(false)
    form.submit()
  }

  const handleSubmit = async () => {
    navigateToStep({ step: EnumNewTransactionParams.UserInformation })
  }

  const handleClickContinue = async () => {
    if (isSeller) {
      setShowOptionSelectedConfirmation(true)
    } else {
      handleSubmit()
    }
  }

  const onAskBuyerPayFeesSwitchChange = () => {
    globalStore.dispatch({
      type: 'UPDATE_ASK_BUYER_PAY_FOR_THE_FEES',
      askBuyerPayForTheFees: !askBuyerPayForTheFees
    })
  }

  return (
    <Row className={classNames('fee-confirm')}>
      <Col className="transaction-form-wrapper flex-col" span={20} offset={2}>
        <InfoModal
          text={infoText}
          open={showInfoModal}
          width={smallModalWidth}
          onClose={() => setShowInfoModal(false)}
        />
        <Modal
          open={showOptionSelectedConfirmation}
          closable={false}
          className="payment-protection-modal"
          width={largeModalWidth}
          centered
          footer={null}
        >
          <div className="payment-protection-modal__body">
            <div>
              Before continuing, confirm the options selected with the buyer since it will impact their transaction.
            </div>
          </div>
          <div className="payment-protection-modal__actions">
            <Button
              className="transaction-form__btn"
              type="primary"
              size="small"
              onClick={() => {
                setShowOptionSelectedConfirmation(false)
              }}
            >
              Back
            </Button>
            <Button
              className="transaction-form__btn"
              type="primary"
              size="small"
              color="primary"
              onClick={submitForm}
            >
              I Confirm
            </Button>
          </div>
        </Modal>

        <Form
          className="fee-confirm__form kuaay-form"
          onFinish={handleSubmit}
          form={form}
        >
          <Title className="fee-confirm__title" level={4}>
            Fee Summary
          </Title>
          <Spacer space={24} />
          <Spacer space={24} />
          {documentEnabled && (
            <>
              <Text strong>Create Sales Documents</Text>
              <br />
              <Text strong>  Fee: </Text>
              <Text>$50</Text>
              <br />
              <Text>What&apos;s Included:</Text>
              <ul>
                <li>Odometer disclosure</li>
                <li>Bill of sale</li>
                <li>Title transfer and registration assistance (state dependent)</li>
              </ul>
              <Spacer space={24} />
            </>
          )}

          {paymentTransferEnabled && (
            <>
              <Text strong> Digital Payment Transfer with Pacer </Text>
              <br />
              <Text strong>  Fee: </Text>
              <Text>1% of transaction amount</Text>
              <br />
              <Text>What&apos;s Included:</Text>
              <ul>
                <li>Secure fund transfer</li>
                <li>Transaction tracking</li>
                <li>Payment verification</li>
              </ul>
              <Spacer space={24} />
            </>
          )}

          {protectionEnabled && (
            <>
              <Text strong> Escrow Payment Protection </Text>
              <br />
              <Text strong>  Fee: </Text>
              <Text>3% of transaction amount</Text>
              <br />
              <Text>What&apos;s Included:</Text>
              <ul>
                <li>Seller must disclose all know issues before the transaction is finalized</li>
                <li>Buyer inspects and confirms the vehicle condition upon delivery</li>
                <li>Pacer assists with dispute resolution if parties aren&apos;t satisfied</li>
              </ul>
              <Spacer space={24} />
            </>
          )}
          {isSeller && (
            <div className="fee-confirm__form-radio-field">
              <Text strong>Who will cover the fees?</Text>
              <Spacer space={12} />
              <Radio.Group
                value={askBuyerPayForTheFees}
                onChange={onAskBuyerPayFeesSwitchChange}
              >
                <Radio value={true}>{isSeller ? 'Let Buyer pay for the fees' : 'I will pay for the fees'}</Radio>
                <Radio value={false}>{isSeller ? 'I will pay for the fees' : 'Let Seller pay for the fees'}</Radio>
              </Radio.Group>
            </div>
          )}
        </Form>
        <Spacer className="flex-grow-1" space={24} />
        <Button
          className="transaction-form__btn"
          type="primary"
          color="primary"
          onClick={handleClickContinue}
        >
          Continue
        </Button>
      </Col>
    </Row>
  )
}
